import { useQuery } from '@apollo/client'
import { GetMemberDetails, UserVariables } from '../../types'
import { GET_MEMBER_DETAILS } from './operations'

interface Props {
  userId: string
  groupId?: string
}

export const useMemberDetails = ({ userId, groupId }: Props) =>
  useQuery<GetMemberDetails, UserVariables>(GET_MEMBER_DETAILS, {
    variables: {
      inputData: {
        id: userId,
        groupId,
      }
    },
  })
